import React from 'react';
import { ReviewSortMode } from '../../domain/taskQueue/reviewSort';
import { SearchableDropdown } from '../../components/SearchableDropdown';

interface ReviewSortControlProps {
  value: ReviewSortMode;
  onChange: (mode: ReviewSortMode) => void;
}

export function ReviewSortControl({ value, onChange }: ReviewSortControlProps) {
  return (
    <div className="flex items-center gap-2 text-xs font-medium text-gray-600">
      <span>Sort</span>
      <SearchableDropdown<ReviewSortMode>
        options={[
          { value: 'age', label: 'Oldest first' },
          { value: 'round', label: 'Round, oldest first' },
        ]}
        value={value}
        onChange={(nextValue) => {
          if (nextValue !== null) onChange(nextValue);
        }}
        placeholder="Select sort"
        searchPlaceholder="Search sort modes"
        ariaLabel="Sort"
        preserveOrder
        className="min-w-[11rem]"
        triggerClassName="min-h-[36px] px-2 py-1 text-sm font-medium text-gray-800"
      />
    </div>
  );
}
